(function () {
  'use strict';

  if (window.FriocellCartUIPolishLoaded) {
    return;
  }

  window.FriocellCartUIPolishLoaded = true;

  function isCartToggleElement(target) {
    return Boolean(
      target.closest('[data-action="toggle-mini-cart"]') ||
      target.closest('[data-action="open-mini-cart"]') ||
      target.closest('.header__cart') ||
      target.closest('.header__cart-link') ||
      target.closest('.header__cart-toggle') ||
      target.closest('a[href="/cart"]') ||
      target.closest('a[href*="/cart"]')
    );
  }

  function closeMiniCart() {
    var miniCart = document.querySelector('#mini-cart');

    if (!miniCart) {
      return;
    }

    miniCart.setAttribute('aria-hidden', 'true');

    var cartToggle = document.querySelector('[data-action="toggle-mini-cart"], .header__cart-toggle');

    if (cartToggle) {
      cartToggle.setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove('mini-cart-open');
    document.body.classList.remove('mini-cart-open');
  }

  function bindOutsideClickToCloseMiniCart() {
    document.addEventListener('click', function (event) {
      var miniCart = document.querySelector('#mini-cart');

      if (!miniCart || miniCart.getAttribute('aria-hidden') === 'true') {
        return;
      }

      if (miniCart.contains(event.target)) {
        return;
      }

      if (isCartToggleElement(event.target)) {
        return;
      }

      closeMiniCart();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMiniCart();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOutsideClickToCloseMiniCart);
  } else {
    bindOutsideClickToCloseMiniCart();
  }
})();